import {createContext, useState} from "react";

export const CountryContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [countries, setCountries] = useState([]);

    // Make the context object:
    const countryContext = {
        countries,
        setCountries,
    };

    // pass the value in provider and return
    return <CountryContext.Provider value={countryContext}>{children}</CountryContext.Provider>;
}

export const {Consumer} = CountryContext;
